import ProductPageLayout from "@/components/ProductPageLayout";
import rullaverho from "@/assets/rullaverho.png?format=webp&w=800";

const RullaverhoAsennus = () => (
  <ProductPageLayout title="Rullaverho asennus" metaDescription="Rullaverhojen asennus Keski-Uudellamaalla. Pimentävät ja valoa suodattavat rullaverhot." image={rullaverho} partner="osio" path="/rullaverho-asennus" alternatePath="/en/roller-blind-installation">
    <p className="text-muted-foreground leading-relaxed">
      Rullaverhot ovat moderni ja tyylikäs ratkaisu ikkunoiden verhoksi. Ne soveltuvat erinomaisesti sekä koteihin että 
      toimistotiloihin. Valitse pimentävä, valoa suodattava tai läpinäkyvä kangas tarpeen mukaan.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Rullaverhon edut</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Minimalistinen ja siisti ulkoasu</li>
      <li>✓ Helppokäyttöinen – keto- tai jousilukitus</li>
      <li>✓ Laaja kangasvalikoima ja värimaailma</li>
      <li>✓ Myös moottoriohjatut versiot saatavilla</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      Asennamme rullaverhot koko Keski-Uudenmaan alueella: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen ja Tuusula. 
      Katso <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osion rullaverhot</a>.
    </p>
  </ProductPageLayout>
);

export default RullaverhoAsennus;
